var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 542,
    height: 938,
    viewBox: "0 0 542 938",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1649_33392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.033 590.699C366.49 522.883 368.96 449.57 345.214 440.11C297.72 403.466 377.592 331.222 425.721 331.222C473.064 331.222 488.66 360.302 534.988 446.679L535.43 447.504C548.933 472.68 589.584 534.757 553.095 575.879C516.607 617.002 466.259 656.748 417.033 590.699Z",
    fill: "#FE9342"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1649_33392",
    x: 0.404449,
    y: 0.964508,
    width: 897.779,
    height: 955.193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 165.129,
    result: "effect1_foregroundBlur_1649_33392"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector6);
export default __webpack_public_path__ + "static/media/vector6.f39382a1fff206204e3320d7d74eecca.svg";
export { ForwardRef as ReactComponent };